import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

//Firebase Operator Dashboard
const firebaseConfig = {
    apiKey: "AIzaSyBtZr95EnVuu-NeNwuUHG4nzCFNSdsvo5Y",
    authDomain: "uno-dashboard-12123.firebaseapp.com",
    projectId: "uno-dashboard-12123",
    storageBucket: "uno-dashboard-12123.firebasestorage.app",
    messagingSenderId: "149826999350",
    appId: "1:149826999350:web:8cb2f4571214b617203497",
    measurementId: "G-4RQSZJ1W10"
};

const unoDashboard = initializeApp(firebaseConfig);

// Initialize Firebase Auth
const auth = getAuth(unoDashboard);

// Set persistence to LOCAL (persists across browser sessions and tabs)
setPersistence(auth, browserLocalPersistence)
    .then(() => {
        console.log("Firebase auth persistence enabled");
    })
    .catch((error) => {
        console.error("Error setting Firebase auth persistence:", error);
    });

export {
    auth as userManagementAuth
};